export default <S>(s: S) => s;
